import {Steps} from 'antd'
import EmptyHolder from 'components/EmptyHolder'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import {LazyPagination} from 'modules/asyncCache/components/LazyPagination'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {Link} from 'react-router-dom'
import {NullAsDefault, renderElse} from 'views/Shared'
import TooltipApp from "components/TooltipApp";
import {formatDate} from "../../../helpers/datetimeHelpers";

const renderDefaultTitle = (item, subPath = 'rel_document') => {
    const rel_document = _.get(item, subPath, {})

    return (
        <div
            key={rel_document?.id}
            className="flex items-center gap-1 text-xs max-lines-2 font-bold leading-tight">
      <span className="text-color-000">
        {formatDate(
            _.get(
                rel_document,
                'effected_date'
            ), 'DD/MM/YYYY')}
          {' - '}
      </span>
            <TooltipApp title={getTitle(rel_document)}>
                <Link
                    target="_blank"
                    className="text-primary"
                    to={getLinkToDetail(rel_document)}>
                    {getTitle(rel_document)}
                </Link>
            </TooltipApp>
        </div>
    )
}

const renderDefaultDescription = (item, subPath = 'rel_document') => {
    const rel_document = _.get(item, subPath, {})
    const {document_no, issued_place} = rel_document ?? {}

    return (
        <Translate>
            {(t) => (
                <div className="flex gap-1 text-2xs leading-tight italic mt-1">
          <span className="text-color-100 font-semibold truncate">
            {getTitle(issued_place)}
          </span>
                    <span className="space-x-1 font-medium text-color-100 whitespace-no-wrap">
            <span className="font-light text-color-400">
              {`- ${t('document no')}: `}
            </span>
                        {document_no}
          </span>
                </div>
            )}
        </Translate>
    )
}

const LinkedDocumentBlock = ({
                                 query,
                                 apiInfo,
                                 hideOnEmpty = false,
                                 subPath = 'rel_document',
                                 subCodiPath = 'rel_codi_document',
                                 renderHeader = NullAsDefault,
                                 renderTitle = renderDefaultTitle,
                                 renderDescription = renderDefaultDescription,
                             }) => {
    const t = useTranslate()
    return (
        <LazyPagination
            auto={false}
            query={query}
            apiInfo={apiInfo}
            renderItem={(item) => (
                <Steps.Step
                    key={item?.id}
                    title={renderTitle(item, subPath)}
                    description={renderDescription(item, subPath)}
                />
            )}
            renderLoadMore={({onClick}) => (
                <div className="mt-1 mb-3 text-right">
                    <div
                        onClick={onClick}
                        className="text-xs italic px-2 cursor-pointer text-color-400 hover:text-color-100">
                        {t('see more')}
                    </div>
                </div>
            )}
            renderWrap={(children, __, total) => (
                <div className="flex flex-col">
                    {renderHeader({total, hideOnEmpty})}
                    {children}
                </div>
            )}
            Wrapper={({count, children}) =>
                count ? (
                    <React.Fragment>
                        <Steps
                            current={0}
                            progressDot
                            direction="vertical"
                            className="LinkedDocumentBlock custom-step-codi-left-menu">
                            {Array.from(children)
                                .filter(_.isArray)
                                .map((item, index) => (
                                    <React.Fragment key={index}>{item}</React.Fragment>
                                ))}
                        </Steps>
                    </React.Fragment>
                ) : (
                    renderElse(
                        hideOnEmpty,
                        <div className="w-full justify-center items-center">
                            <EmptyHolder/>
                        </div>
                    )
                )
            }
        />
    )
}

export default LinkedDocumentBlock
